import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { BUTTON_HEIGHT_40 } from '../../../../Button'
import { CustomSelect } from '../../../../CustomSelect'
import { FormBody, FormFieldSelect } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { ListItem } from '../../../../ListItem'
import { Content } from '../../../../Modal'
import { EMAIL_CREATION_FORM_FIELD_NAME_PRINTER } from '../../EmailCreationForm.constants'

import {
  getListItemProps,
  getPrinterSelectLabel,
  getPrinterSelectValue,
} from './FormFields.utils'

import * as styles from './FormFields.module.css'

export function FormFields(props) {
  const { options } = props

  const { t } = useTranslation()

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: null,
        ButtonClear: null,
        UploadComponent: null,
        cancelProps: {
          height: BUTTON_HEIGHT_40,
          onClick: props.onCancel,
        },
        className: styles.actions,
        submitProps: {
          height: BUTTON_HEIGHT_40,
          title: t('Modal.SaveBtnKey'),
        },
      }}
    >
      <Content>
        <span className={styles.message}>
          {t('Email.ModalSelectPrinterMessageKey')}
        </span>
        <span className={styles.label}>{t('Email.SelectPrinterLabelKey')}</span>
        <FormikField
          Component={FormFieldSelect}
          Field={Fragment}
          ListItem={ListItem}
          Select={CustomSelect}
          getLabel={getPrinterSelectLabel}
          getListItemProps={getListItemProps}
          getValue={getPrinterSelectValue}
          name={EMAIL_CREATION_FORM_FIELD_NAME_PRINTER}
          options={options}
        />
      </Content>
    </FormBody>
  )
}

export default FormFields
